module.exports = __webpack_public_path__ + "img/a5.3062e0a4.jpg";